import { useState } from "react";
import { Loader2, Play } from "lucide-react";
import { GAMES, GameBg, GameBadge } from "./WagerPicker";

const KEY = "fc_welcome_seen";
export const welcomeSeen = () => localStorage.getItem(KEY) === "1";

// First-visit pop-up: +£10, and the only way on is picking one of the two games.
const WelcomeBonus = ({ onPick }) => {
  const [busy, setBusy] = useState(null);
  const pick = (g) => {
    if (busy) return;
    localStorage.setItem(KEY, "1");
    setBusy(g.id);
    Promise.resolve(onPick(g)).finally(() => setBusy(null));
  };
  return (
    <div data-testid="welcome-bonus-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm rounded-2xl border border-[#10B981]/40 bg-[#1E293B] p-6 text-center text-white fade-up">
        <div className="text-[12px] label-eyebrow text-[#10B981]">Welcome to Footie Clash</div>
        <div data-testid="welcome-bonus-amount" className="font-display font-extrabold text-7xl text-[#10B981] tabular mt-2 leading-none">+£30</div>
        <p className="text-[#94A3B8] text-sm mt-3">It's in your balance. Stake it against Pep and double it.<br />Pick a game to start.</p>
        <div className="mt-6 space-y-2.5">
          {GAMES.map((g) => (
            <button key={g.id} data-testid={`welcome-game-${g.id}`} onClick={() => pick(g)}
              className="on-dark relative overflow-hidden w-full rounded-2xl px-4 py-5 flex items-center gap-3 text-left text-white border-2 border-[#34D399] shadow-[0_0_24px_rgba(16,185,129,0.35)]">
              <GameBg game={g} />
              <span className="relative">{busy === g.id ? <span className="w-12 h-12 flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin" /></span> : <GameBadge game={g} size="w-12 h-12" icon="w-7 h-7" />}</span>
              <span className="relative flex-1 font-display font-black uppercase text-3xl leading-[0.9] tracking-wide drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]">{g.title}</span>
              <span className="relative rounded-xl px-4 py-2.5 text-base font-extrabold uppercase flex items-center gap-1.5 bg-[#10B981] text-[#0F172A] shadow-lg shrink-0"><Play className="w-4 h-4 fill-current" /> Play</span>
            </button>
          ))}
        </div>
        <p className="text-[10px] text-[#64748B] mt-4">Virtual £ for play only.</p>
      </div>
    </div>
  );
};

export default WelcomeBonus;
